(($) => {
  $("#quick-access").hide();

  $('.nice-select').niceSelect("update");

  $(".togglers").on("click", function(){
    let id = $(this).attr("data-toggle");
      $.ajax({
        url: "/furb2020/web/contato",
        type: 'POST',
        success: () => {
          $("#search, #quick-access").hide();
          $("#" + id).show();
        }
      })
  })
})(jQuery);
